module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 15 15"
    }
  }, [_c('defs'), _c('g', {
    attrs: {
      "id": "РЎР»РѕР№_2",
      "data-name": "РЎР»РѕР№ 2"
    }
  }, [_c('g', {
    attrs: {
      "id": "РЎР»РѕР№_1-2",
      "data-name": "РЎР»РѕР№ 1"
    }
  }, [_c('path', {
    staticClass: "cls-1",
    attrs: {
      "d": "M7.47,15H1.29A1.14,1.14,0,0,1,0,13.7V1.34C0,.41.41,0,1.33,0H13.68C14.58,0,15,.41,15,1.31v12.4c0,.87-.42,1.28-1.3,1.29Zm0-13.37c-1.8,0-3.61,0-5.42,0-.33,0-.44.07-.44.42q0,5.45,0,10.9c0,.34.11.42.44.42H12.92c.33,0,.44-.07.44-.42,0-3.63,0-7.27,0-10.9,0-.34-.1-.43-.43-.42C11.12,1.64,9.31,1.63,7.5,1.63Z"
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d1f3c08","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/AppSvgIconNew/templates/icons/square.vue
// module id = bf4caf334ac318bd72fa
// module chunks = 89